module.exports = __webpack_public_path__ + "img/quotes.5fc05f98.png";